import { render, staticRenderFns } from "./d-book-user-review-social.vue?vue&type=template&id=68777dd0&scoped=true&"
import script from "./d-book-user-review-social.vue?vue&type=script&lang=js&"
export * from "./d-book-user-review-social.vue?vue&type=script&lang=js&"
import style0 from "./d-book-user-review-social.vue?vue&type=style&index=0&id=68777dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68777dd0",
  null
  
)

export default component.exports